export const environment = {
  production: true,
  firebaseConfig : {
    // apiKey: "AIzaSyCLlDDrz_9AsxthhZn8ixmKoxj8Cwoeu64",
    // authDomain: "legully-attendance.firebaseapp.com",
    // projectId: "legully-attendance",
    // storageBucket: "legully-attendance.appspot.com",
    // messagingSenderId: "298619217617",
    // appId: "1:298619217617:web:762813a493b2d4c31047f0",
    // measurementId: "G-GMVRQQ8JPM"
  }

};
